import '../style/App.css';
import NavBar from './NavBar';
import Login from './Login';
import SignUp from './SignUp';
import Account from './Account';
import EditPhoto from '../form/EditPhoto';
import PhotoDetails from './PhotoDetails';
import PhotoContainer from './PhotosContainer';
import { loginUser } from '../redux/userSlice';
import { useDispatch } from 'react-redux'
import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory } from "react-router-dom";

function App() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false)
  const [userPhotos, setUserPhotos] = useState([])
  const [favoriteList, setFavoriteList] = useState([])
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch("https://fotoset.herokuapp.com/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((r) => {
        return r.json().then((data) => {
          if (r.ok) {
            return data;
          } else {
            throw data;
          }
        });
      })
      .then((user) => {
        dispatch(loginUser(user));
        setUserPhotos(user.photos)
        setFavoriteList(user.favorites)
        setIsLoaded(true)
        if (!user.username) {
          history.push('/login')
        }
      });
  }, [dispatch, history]);

      const handleDeleteUserPhoto = (photoRemove) => {
        const newPhotoList = userPhotos.filter((p) => p.id !== photoRemove.id)
        setUserPhotos(newPhotoList)
      }

      const handleAddUserPhoto = (newUserPhoto) => {
        const updateUserPhoto = [...userPhotos, newUserPhoto]
        setUserPhotos(updateUserPhoto)
      }

      const handleAddFavorite = (favoriteToAdd) => {
        setFavoriteList([...favoriteList, favoriteToAdd])
        console.log(favoriteToAdd, "new favorite")
      }
    
      const handleDeleteFavorite = (favoriteToRemove) => {
        const newFavoriteList = favoriteList.filter((fav) => fav.id !== favoriteToRemove.id)
        setFavoriteList(newFavoriteList)
      }

      const handleUpdatePhoto = (updatePhotoInfo) => {
        const newPhotoInfo = userPhotos.filter((photo) => photo.id !== updatePhotoInfo.id)
        setUserPhotos(newPhotoInfo)
      }

  return (
    <div className="App">
      <NavBar />
      <main>
      <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/signup">
            <SignUp />
          </Route>
          <Route exact path="/account">
            <Account
            handleUpdatePhoto={handleUpdatePhoto}
            handleAddFavorite={handleAddFavorite} 
            handleDeleteUserPhoto={handleDeleteUserPhoto}
            handleDeleteFavorite={handleDeleteFavorite}
            favoriteList={favoriteList} 
            userPhotos={userPhotos} 
            isLoaded={isLoaded} 
            />
          </Route>
          <Route exact path="/">
            <PhotoContainer 
            handleAddUserPhoto={handleAddUserPhoto}
            />
          </Route>
          <Route exact path="/photo/:id">
            <PhotoDetails 
            handleAddFavorite={handleAddFavorite}
            favoriteList={favoriteList}
            />
          </Route>
          <Route exact path="/editphoto">
            <EditPhoto userPhotos={userPhotos} />
          </Route>
      </Switch>
      </main>
    </div>
  );
}

export default App;

